import request from '@/utils/request'

const dmUrl = 'https://www.xiqiaoshantour.com'
// const dmUrl = window.location.origin

const api = {
  user: '/user',
  service: '/service',
  orgTree: '/org/tree',
  publicApi: dmUrl + '/api'// http://39.104.202.233/api https://www.xiqiaoshantour.com
}

export default api

// 西樵概况
export function getGK () {
  return request({
    url: api.publicApi + '/cn/cnIntoOutline/open/list',
    method: 'get',
    params: {
    }
  })
}

// 景点介绍
export function getZDRYFBList () {
  return request({
    url: api.publicApi + '/cn/cnIntoSpot/open/list',
    method: 'get',
    params: {
    }
  })
}

// 文化
export function getWHList (typeName) {
  return request({
    url: api.publicApi + '/cn/cnIntoCulture/open/list',
    method: 'get',
    params: {
      'typeName': typeName
    }
  })
}

// 走进西樵山菜单
export function getZJXQSList () {
  return request({
    url: api.publicApi + '/cn/cnIntoBase/open/list',
    method: 'get',
    params: {
    }
  })
}

// 玩遍 行
export function getPlayForFoot (type) {
  return request({
    url: api.publicApi + `/cn/cnTravelTraffic/open/list/${type}`,
    method: 'get',
    params: {

    }
  })
}

// 玩遍 行 封面 /detail/${id}`,
export function getPlayForFootCover (id) {
  return request({
    url: api.publicApi + `/cn/cnTravelTrafficType/manage/detail/${id}`,
    method: 'get',
    params: {
    }
  })
}

// 玩遍 食
export function getPlayForFood () {
  return request({
    url: api.publicApi + '/cn/cnTravelDiet/open/list',
    method: 'get',
    params: {
    }
  })
}

// 玩遍 住 /cn/cnTravelLearn/open/list
export function getPlayForLive () {
  return request({
    url: api.publicApi + '/cn/cnTravelStay/open/list',
    method: 'get',
    params: {
    }
  })
}

// 玩遍 学
export function getPlayForStudy () {
  return request({
    url: api.publicApi + '/cn/cnTravelLearn/open/list',
    method: 'get',
    params: {
    }
  })
}

// 玩遍 购 /cn/cnTravelBuy/open/list
export function getPlayForBuy () {
  return request({
    url: api.publicApi + '/cn/cnTravelBuy/open/list',
    method: 'get',
    params: {
    }
  })
}

// 玩遍 乐 /cn/cnTravelPlay/open/list
export function getPlayForHappy () {
  return request({
    url: api.publicApi + '/cn/cnTravelPlay/open/list',
    method: 'get',
    params: {
    }
  })
}

// 玩遍西樵山菜单
export function getPlayList () {
  return request({
    url: api.publicApi + '/cn/cnTravelBase/open/list',
    method: 'get',
    params: {
    }
  })
}

// 醉美 揽胜  /cn/cnBeautyArea/open/list
export function getBeautyFor (typeName) {
  return request({
    url: api.publicApi + '/cn/cnBeautyArea/open/list',
    method: 'get',
    params: {
      'typeName': typeName
    }
  })
}

// 醉美 影音
export function getBeautyForMove () {
  return request({
    url: api.publicApi + '/cn/cnBeautyVideo/open/list',
    method: 'get',
    params: {
    }
  })
}

// 醉美  语音
export function getBeautyForRadio () {
  return request({
    url: api.publicApi + '/cn/cnBeautyAudio/open/list',
    method: 'get',
    params: {
    }
  })
}

// 醉美  720
export function getBeautyFor720 () {
  return request({
    url: api.publicApi + '/cn/cnBeautyPanorama/open/list',
    method: 'get',
    params: {
    }
  })
}

// 醉美  书籍 cnBeautyBook
export function getBeautyForSJ () {
  return request({
    url: api.publicApi + '/cn/cnBeautyBook/open/list',
    method: 'get',
    params: {
    }
  })
}

// 醉美菜单
export function getBeautyList () {
  return request({
    url: api.publicApi + '/cn/cnBeautyBase/open/list',
    method: 'get',
    params: {
    }
  })
}

// 智游 菜单全部
export function getZHIYOUListAll () {
  return request({
    url: api.publicApi + '/cn/cnRoute/open/list_all',
    method: 'get',
    params: {
    }
  })
}
// 智游 菜单
export function getZHIYOUList () {
  return request({
    url: api.publicApi + '/cn/cnRoute/open/list',
    method: 'get',
    params: {
    }
  })
}

// 评论
export function getOtherComment (flag) {
  return request({
    url: api.publicApi + `/cn/cnOtherComment/open/list/${flag}`,
    method: 'get',
    params: {
    }
  })
}

// 添加评论
export function addOtherComment (info) {
  return request({
    url: api.publicApi + '/cn/cnOtherComment/manage/add',
    method: 'post',
    data: info
  })
}

// 活动回顾
export function getActivity () {
  return request({
    url: api.publicApi + '/cn/cnMessageActivity/open/list',
    method: 'get',
    params: {
    }
  })
}

// 工作状态
export function getNews () {
  return request({
    url: api.publicApi + '/cn/cnMessageNews/open/list',
    method: 'get',
    params: {
    }
  })
}

// 公告
export function getNotice () {
  return request({
    url: api.publicApi + '/cn/cnMessageNotice/open/list',
    method: 'get',
    params: {
    }
  })
}

// 公告详情 /cn/cnMessageNotice/manage/detail/{id}
export function getNoticeById (id) {
  return request({
    url: api.publicApi + `/cn/cnMessageNotice/manage/detail/${id}`,
    method: 'get'
  })
}

// 醉美 影音
export function getcnBeautyVideo (title) {
  return request({
    url: api.publicApi + '/cn/cnBeautyVideo/open/list',
    method: 'get',
    params: {
      'title': title
    }
  })
}

// 醉美 语音
export function getcnBeautyAudio (title) {
  return request({
    url: api.publicApi + '/cn/cnBeautyAudio/open/list',
    method: 'get',
    params: {
      'title': title
    }
  })
}
// 讯游西樵山菜单  /cn/cnMessageBase/open/list
export function getXUYOUlist () {
  return request({
    url: api.publicApi + '/cn/cnMessageBase/open/list',
    method: 'get',
    params: {

    }
  })
}

// 历史荣誉
export function gethistoryList () {
  return request({
    url: api.publicApi + '/cn/cnIntoTime/open/list',
    method: 'get',
    params: {

    }
  })
}

// 文化类型获取
export function getCultureTypeList () {
  return request({
    url: api.publicApi + '/cn/cnIntoCultureType/open/list',
    method: 'get',
    params: {

    }
  })
}



// WEBPACK FOOTER //
// ./src/api/public.js